// https://stackoverflow.com/questions/21646738/convert-hex-to-rgba

import { stringWithoutWhitespace } from './strings';

export function hexToRgbA(hex) {
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        let digits: string[] = hex.substring(1).split('');
        if (digits.length === 3) {
            digits = [digits[0], digits[0], digits[1], digits[1], digits[2], digits[2]];
        }
        const c = Number(`0x${digits.join('')}`);
        // eslint-disable-next-line no-bitwise
        return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},1)`;
    }
    return 'rgba(0,0,0,1)';
}

/** `#336699`, `336699`, `#f80` or `f80` to `[r, g, b]`; anything else is black. */
export function hexToRgbTuple(hex: string | null | undefined): [number, number, number] {
    const digits = (hex ?? '').replace(/^#/, '');
    if (!/^([A-Fa-f0-9]{3}){1,2}$/.test(digits)) return [0, 0, 0];

    const full = digits.length === 3 ? digits.replace(/./g, c => c + c) : digits;
    return [0, 2, 4].map(i => parseInt(full.slice(i, i + 2), 16)) as [number, number, number];
}

export function hexToRgbString(hex: string) {
    const [r, g, b] = hexToRgbTuple(hex);
    return `rgb(${r}, ${g}, ${b})`;
}

const matchRgbaColors = /rgba\((\d{1,3}),(\d{1,3}),(\d{1,3}),(([0-1])?|\d(\.\d*)?)\)/;
const matchRgbColors = /rgb\((\d{1,3}),(\d{1,3}),(\d{1,3})\)/;
export function colorStringToRgbaTuple(color: string): string[] {
    const colorToCheck = stringWithoutWhitespace(color);
    let colorParts = [0, 0, 0, 1];
    if (color.startsWith('rgba')) {
        const parts = matchRgbaColors.exec(colorToCheck)?.slice(1, 5);
        if (parts?.length === 4)
            colorParts = [Number(parts[0]), Number(parts[1]), Number(parts[2]), Number(parts[3])];
    }
    if (color.startsWith('rgb(')) {
        const parts = matchRgbColors.exec(colorToCheck)?.slice(1, 4);
        if (parts?.length === 3)
            colorParts = [Number(parts[0]), Number(parts[1]), Number(parts[2]), 1];
    }
    if (color.startsWith('#')) {
        return colorStringToRgbaTuple(hexToRgbA(colorToCheck));
    }

    return colorParts
        .map((part, index) => {
            if (index === 3) return part < 0 || part > 1 ? 1 : part;
            return part > 255 || part < 0 ? 0 : part;
        })
        .map(number => String(number));
}
